"use client"
import { GetPageQuery } from "apollo"
import { HomeIcon } from "ui/icons"

import { CustomBreadcrumbs, DealsCarousel } from "ui"

import styled from "@emotion/styled"
import { getParentsArray } from "lib/utils"
import { BlockRenderer, findProperty } from "utils"
import AccordionFaqWithIcon from "./AccordionFaqWithIcon"
import AccordionFaqWrapper from "./AccordionFaqWrapper"
import BrandsValueWrapper from "./BrandsValueWrapper"
import MainBanner from "./MainBanner"
import Video from "./Video"
import Wallet from "./Wallet"

type Props = {
  data: GetPageQuery
}

const components = {
  appBlock: MainBanner,
  accordionFaqMain: AccordionFaqWithIcon,
  DealsCarousel: DealsCarousel,
  videoBlock: Video,
  accordionFaqMain1: AccordionFaqWrapper,
  wallet: Wallet,
  carrouselImgTxt: BrandsValueWrapper,
}

const Padding = styled.div`
  padding-left: 28px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 100px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 150px;
  }
`
function PazClub({ data }: Props) {
  const parents = getParentsArray(data.page, 3)
  return (
    <>
      <Padding>
        <CustomBreadcrumbs
          current={parents[parents.length - 1]}
          parents={[{ title: <HomeIcon />, url: "/" }]}
        />
      </Padding>
      {findProperty(data.page, "blocks")?.blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => (
          <BlockRenderer
            key={index}
            index={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
          ></BlockRenderer>
        ),
      )}
    </>
  )
}

export default PazClub
